<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
    <div class="flex justify-between header-table" #pageOptionBtnGroup>
        <div class="title-page"><span class="title">Xác nhận điều chuyển nhân sự</span>
            <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
        </div>
        <div class="btn-option flex">
            <page-btn-option [isAddBtn]="true" (add)="popupAdd()" [isDeleteBtn]="true" (delete)="delete()"
                [isExcelBtn]="true" (excel)="exportExcel()">
            </page-btn-option>
        </div>
    </div>
    <form nz-form class="ant-advanced-search-form" #pageSearch autocomplete="off">
        <div nz-row [nzGutter]="24">
            <div nz-col nxSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label #label nzSpan="24" nzFor="provinceId">Tỉnh thành</nz-form-label>
                    <nz-form-control nzSpan="24" nzErrorTip="Nhập tỉnh thành">
                        <asc-autocomplete label="Tỉnh thành" [ascModel]="provinceControl"
                            (ascModelChange)="changeProvince($event)" placeholder="Chọn tỉnh thành..."
                            [getListAC]="getProvinceACFn">
                        </asc-autocomplete>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label #label nzSpan="24" nzFor="districtId">Quận huyện</nz-form-label>
                    <nz-form-control nzSpan="24" nzErrorTip="Nhập quận huyện">
                        <asc-autocomplete label="Quận huyện" [ascModel]="districtControl"
                            (ascModelChange)="changeDistrict($event)" placeholder="Chọn quận huyện..."
                            [getListAC]="getDistrictACFn">
                        </asc-autocomplete>
                    </nz-form-control>
                </nz-form-item>
            </div>


            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label #label nzFor="transferToEatosId" nzSpan="24">Đơn vị xác nhận
                    </nz-form-label>
                    <nz-form-control nzSpan="24">
                        <asc-autocomplete [ascModel]="SchoolControl" (ascModelChange)="changeSchool($event)"
                            [placeholder]="'Chọn đơn vị xác nhận'" [getListAC]="getSchoolACFn">
                        </asc-autocomplete>
                    </nz-form-control>
                </nz-form-item>
            </div>


            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24" nzFor="ma">Đơn vị tiếp nhận</nz-form-label>
                    <nz-form-control nzSpan="24">
                        <input nz-input [(ngModel)]="commonFilter.TransferToEatosName"
                            [ngModelOptions]="{standalone: true}" [placeholder]="'Nhập đơn vị tiếp nhận...'"
                            [ngModelOptions]="{standalone: true}">
                    </nz-form-control>
                </nz-form-item>
            </div>


            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24" nzFor="ma">Mã định danh</nz-form-label>
                    <nz-form-control nzSpan="24">
                        <input nz-input [(ngModel)]="commonFilter.StudentCode" [ngModelOptions]="{standalone: true}"
                            [placeholder]="'Nhập mã định danh...'" [ngModelOptions]="{standalone: true}">
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24" nzFor="hoTen">Họ tên</nz-form-label>
                    <nz-form-control nzSpan="24">
                        <input type="text" nz-input [(ngModel)]="commonFilter.FullName"
                            [ngModelOptions]="{standalone: true}" [placeholder]="'Nhập họ tên...'"
                            [ngModelOptions]="{standalone: true}">
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                <nz-form-item>
                    <nz-form-label nzSpan="24" nzFor="YearOfBirth">Năm sinh</nz-form-label>
                    <nz-form-control nzSpan="24">
                        <nz-input-number [(ngModel)]="commonFilter.YearOfBirth" [nzMin]="1970" [nzMax]="9999"
                            [nzStep]="1" nzPlaceHolder="Nhập năm sinh" [ngModelOptions]="{standalone: true}">
                        </nz-input-number>
                    </nz-form-control>
                </nz-form-item>
            </div>
            <ng-container *ngIf="isCollapse == false">

                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24">Giới tính</nz-form-label>
                        <nz-form-control nzSpan="24">
                            <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                                <label nz-radio nzValue="-5">Tất cả</label>
                                <label nz-radio nzValue="1">Nam</label>
                                <label nz-radio nzValue="0">Nữ</label>
                            </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
                        <asc-autocomplete [ascModel]="TypeOfPersonnelControl"
                            (ascModelChange)="changeTypeOfPersonnel($event)" [placeholder]="'Chọn dạng...'"
                            [getListAC]="getTypeOfPersonnelACFn"></asc-autocomplete>
                    </nz-form-item>
                </div>
                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24">Vị trí công tác CBQL</nz-form-label>
                        <asc-autocomplete [ascModel]="PositionControl" (ascModelChange)="changePosition($event)"
                            [placeholder]="'Chọn chức vụ...'" [getListAC]="getPositionACFn"></asc-autocomplete>
                    </nz-form-item>
                </div>
                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24">Vị trí công tác Giáo viên/Giảng viên</nz-form-label>
                        <asc-autocomplete [ascModel]="PositionGVControl" (ascModelChange)="changePositionGV($event)"
                            [placeholder]="'Chọn chức vụ...'" [getListAC]="getPositionGVACFn"></asc-autocomplete>
                    </nz-form-item>
                </div>
                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24" nzFor="ma">Ngày Quyết định</nz-form-label>
                        <nz-form-control nzSpan="12">
                            <nz-date-picker [(ngModel)]="fromDate" (ngModelChange)="onChangeDate($event)"
                                [ngModelOptions]="{standalone: true}" nzPlaceHolder="Ngày quyết định"
                                [nzFormat]="dateFormat"></nz-date-picker>
                        </nz-form-control>
                        <nz-form-control nzSpan="12">
                            <nz-date-picker [(ngModel)]="toDate" (ngModelChange)="onChangeDate($event)"
                                [ngModelOptions]="{standalone: true}" nzPlaceHolder="Ngày hiệu lực"
                                [nzFormat]="dateFormat"></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col nzSpan="24">
                    <nz-form-item>
                        <nz-form-label nzSpan="24" nzFor="transferReason" #label>Lý do</nz-form-label>
                        <nz-form-control nzSpan="24">
                            <textarea rows="4" nz-input [(ngModel)]="commonFilter.TransferReason"
                                placeholder="Nhập lý do" maxlength="550"
                                [ngModelOptions]="{standalone: true}"></textarea>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                    <nz-form-item>
                        <nz-form-label nzSpan="24">Giới tính</nz-form-label>
                        <nz-form-control nzSpan="24">
                            <nz-radio-group [(ngModel)]="commonFilter.Gender" [ngModelOptions]="{standalone: true}">
                                <label nz-radio nzValue="-5">Tất cả</label>
                                <label nz-radio nzValue="1">Nam</label>
                                <label nz-radio nzValue="0">Nữ</label>
                            </nz-radio-group>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <ng-container *ngIf="isCollapse == false">


                    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-label nzSpan="24">Loại nhân sự</nz-form-label>
                            <asc-autocomplete [ascModel]="TypeOfPersonnelControl"
                                (ascModelChange)="changeTypeOfPersonnel($event)" [placeholder]="'Chọn dạng...'"
                                [getListAC]="getTypeOfPersonnelACFn"></asc-autocomplete>
                        </nz-form-item>
                    </div>
                    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-label nzSpan="24">Vị trí công tác CBQL</nz-form-label>
                            <asc-autocomplete [ascModel]="PositionControl" (ascModelChange)="changePosition($event)"
                                [placeholder]="'Chọn chức vụ...'" [getListAC]="getPositionACFn"></asc-autocomplete>
                        </nz-form-item>
                    </div>
                    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-label nzSpan="24">Vị trí công tác Giáo viên/Giảng viên</nz-form-label>
                            <asc-autocomplete [ascModel]="PositionGVControl" (ascModelChange)="changePositionGV($event)"
                                [placeholder]="'Chọn chức vụ...'" [getListAC]="getPositionGVACFn"></asc-autocomplete>
                        </nz-form-item>
                    </div>
                    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-label nzSpan="24">Lý do</nz-form-label>
                            <input nz-input [(ngModel)]="commonFilter.TransferReason" type="text"
                                placeholder="Nhập lý do" maxlength="550" [ngModelOptions]="{standalone: true}">
                        </nz-form-item>
                    </div>
                    <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
                        <nz-form-item>
                            <nz-form-label nzSpan="24" nzFor="ma">Ngày Quyết định</nz-form-label>
                            <nz-form-control nzSpan="12">
                                <nz-date-picker [(ngModel)]="fromDate" (ngModelChange)="onChangeDate($event)"
                                    [ngModelOptions]="{standalone: true}" nzPlaceHolder="Ngày quyết định"
                                    [nzFormat]="dateFormat"></nz-date-picker>
                            </nz-form-control>
                            <nz-form-control nzSpan="12">
                                <nz-date-picker [(ngModel)]="toDate" (ngModelChange)="onChangeDate($event)"
                                    [ngModelOptions]="{standalone: true}" nzPlaceHolder="Ngày hiệu lực"
                                    [nzFormat]="dateFormat"></nz-date-picker>
                            </nz-form-control>
                        </nz-form-item>
                    </div>
                </ng-container>
                <div *ngIf="this.divisibleForFour" nz-col nzSpan="24">
                    <div style="visibility: hidden; margin-top: 5px">i</div>
                </div>
            </ng-container>
        </div>
        <div nz-row>
            <div nz-col [nzSpan]="24" class="search-area">
                <button nz-button class="flex items-center justify-center"
                    [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'" (click)="toggleCollapse()" nz-tooltip><i nz-icon
                        nzType="filter" nzTheme="outline"></i></button>
                <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
                    <button nz-button class="flex items-center justify-center" (click)="clear()"
                        nzTooltipTitle="Xóa tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="search()"><i
                            nz-icon nzType="clear" nzTheme="outline"></i></button>
                    <button nz-button class="flex items-center justify-center" [nzType]="'primary'">Tìm kiếm</button>
                </ng-container>
                <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
                    <button nz-button class="flex items-center justify-center" (click)="clear()"
                        nzTooltipTitle="Xóa tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear"
                            nzTheme="outline"></i></button>
                    <button nz-button class="flex items-center justify-center" style="width: 100px;"
                        [nzType]="'primary'" nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip
                        (click)="search()"><i nz-icon nzType="search" nzTheme="outline"></i></button>
                </ng-container>
                <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
                    <button nz-button class="flex items-center justify-center" (click)="clear()"
                        nzTooltipTitle="Xóa tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear"
                            nzTheme="outline"></i></button>
                    <button nz-button class="flex items-center justify-center" [nzType]="'primary'"
                        (click)="search()"><i nz-icon nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
                </ng-container>
            </div>
        </div>
    </form>
    <div class="relative">
        <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="listStudent"
            [nzFrontPagination]="false" nzSize="small" [nzScroll]="{x: width +'px', y: height + 'px'}"
            class="absolute w-full" [nzTotal]="total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
            [nzPageSizeOptions]="pageSizeOptions" (nzPageIndexChange)="pageIndexEvent($event)"
            (nzPageSizeChange)="pageSizeEvent($event)" (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
            [nzLoading]="loading">
            <thead>
                <tr #pageHeaderTable>
                    <th nzLeft nzWidth="50px" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
                        (nzCheckedChange)="onAllChecked($event)"></th>
                    <th nzWidth="50px" nzLeft>STT</th>
                    <th nzLeft nzWidth="115px">Mã định danh</th>
                    <th nzLeft nzWidth="150px">Họ tên</th>
                    <th nzWidth="50px">Giới tính</th>
                    <th nzWidth="50px">Năm sinh</th>
                    <th nzWidth="100px">Loại nhân sự</th>
                    <th nzWidth="150px">Vị trí công tác</th>
                    <th nxWidth="250px">Đơn vị xác nhận</th>
                    <th nxWidth="250px">Đơn vị tiếp nhận</th>
                    <th nxWidth="70px">Số quyết định</th>
                    <th nzWidth="100px">Ngày quyết định</th>
                    <th nzWidth="100px">Ngày hiệu lực</th>
                    <th nzWidth="150px">Lý do</th>
                    <th class="text-center" nzWidth="75px">Thao tác</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of Table.data; let i = index">
                    <ng-container *ngIf="item.tranferType !== 1">
                        <td nzLeft></td>
                    </ng-container>
                    <ng-container *ngIf="item.tranferType === 1">
                        <td nzLeft [nzChecked]="setOfCheckedId.has(item.id)"
                            (nzCheckedChange)="onItemChecked(item.id, $event)">
                        </td>
                    </ng-container>
                    <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
                    <td nzLeft>{{item.staffCode}}</td>
                    <td nzLeft>{{item.fullName}}</td>
                    <td>{{item.gender | gender}}</td>
                    <td>{{item.yearOfBirth }}</td>
                    <td>{{item.typeOfPersonnelName}}</td>
                    <td>{{item.positionName ? item.positionName : item.positionGVName}}</td>
                    <td>{{item.educationAndTrainingName}}</td>
                    <td>{{item.transferToEatosName}}</td>
                    <td>{{item.decisionNumber}}</td>
                    <td> {{item.transferDate| date:'dd/MM/yyyy' }} </td>
                    <td> {{item.effectiveDate| date:'dd/MM/yyyy' }} </td>
                    <td>{{item.transferReason}}</td>
                    <td>
                        <table-btn-row *ngIf="item.tranferType === 1" [isEditBtn]="true" (edit)="popupEdit(item)">
                        </table-btn-row>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ total }} </ng-template>
<ng-template #tplTitle>
    <div class="flex justify-between">
        <span>{{ titlePopup }}</span>
        <button nz-button class="btn-modal-reside" (click)="handlerResizePopup()">
            <i nz-icon [nzType]="!isResizdePopup ? 'arrows-alt': 'shrink'" nzTheme="outline"></i>
        </button>
    </div>
</ng-template>
